// extracted by mini-css-extract-plugin
module.exports = {"text":"Wl-BVDL_0XTIDvj_U_0Z_"};